export const mainNavItems = [
  { label: "Reformer", href: "/reformer-pilates" },
  { label: "Kurse", href: "/#kurse" },
  { label: "Wellness", href: "/#wellness" },
  { label: "Pakete", href: "/#pakete" },
];

// Mock data for studio sub-pages
export const studioSections: any[] = [];

export function getStudioSectionBySlug(_slug: string) {
  return undefined;
}

export function getAllSlugs() {
  return [];
}
